export default function wrap_filters() {
  if ($('.ewd-uwcf-filters').length !== 0) {
    //$('.product-filter-wrapper').appendTo('.woocommerce-products-header');
    $('.ewd-uwcf-filters').appendTo('.product-filter-wrapper');
    $('.product-filter-wrapper').show();
    $('.ewd-uwcf-all-color').text('Visa alla färger').addClass('button');

    //Gör så att alla olika produktkategorifilter är gömda bakom en dropdown till en början
    if ($('.ewd-uwcf-min-price').length > 0) {
      var min = parseInt($('.ewd-uwcf-min-price').val(),10);
      var max = parseInt($('.ewd-uwcf-max-price').val(),10);
      //console.log(min,max);
      $('.wl-categories').append('<div class="product-filter-wrapper"><div class="single-category"><span class="h4">PRIS</span><div class="range-slider"><div class="multi-range"><input type="range" min="'+min+'" max="'+max+'" value="'+min+'" id="lower"><input type="range" min="'+min+'" max="'+max+'" value="'+max+'" id="upper"></div><div id="price_filter_lower">'+min+'</div><div id="price_filter_upper">'+max+'</div><div class="buttons"><button id="filter_price" class="button">Filtrera</button><button id="reset_price" class="button">Återställ</button></div></div></div></div>');

      $('.ewd-uwcf-tag-filters-wrap').append('<div class="ewd-uwcf-color-item ewd-uwcf-all-color button">Visa alla varumärken</div>');

      $('.ewd-uwcf-all-color').click(function(){
        window.location.href = window.location.origin + window.location.pathname;
      });

      $('#filter_price').click(function(){
        var lowerVal = $('#lower').val();
        var upperVal = $('#upper').val();
        $('input[name="min_price"]').val(lowerVal);
        $('input[name="max_price"]').val(upperVal).change();
      });

      $('#reset_price').click(function(){
        var price_query = window.location.search;
        var min_price_index = price_query.indexOf('min_price=');
        if (min_price_index > -1) {
          var min_price_index_end = find_index(min_price_index, price_query);
          price_query = replace_between(price_query, min_price_index, min_price_index_end, '');
        }
        var max_price_index = price_query.indexOf('max_price=');
        if (max_price_index > -1) {
          var max_price_index_end = find_index(max_price_index, price_query);
          price_query = replace_between(price_query, max_price_index, max_price_index_end, '');
        }
        window.location.search = price_query;
      });

      function find_index(start, complete_string) {
        for (var i = start; i < complete_string.length; i++) {
          if (complete_string[i] == '&') {
            return i;
          }
        }
        return complete_string.length;
      }

      function replace_between(text, start, end, what) {
        return text.substring(0, start) + what + text.substring(end);
      }

      if ($('#lower').length > $('#upper').length) {
      	var lowerSlider = document.querySelector('#lower');
        var upperSlider = document.querySelector('#upper');
        var lowerVal = min;
        var upperVal = max;

        upperSlider.oninput = function(e) {
          e.preventDefault();
  		    lowerVal = parseInt(lowerSlider.value);
  		    upperVal = parseInt(upperSlider.value);
          if (upperVal < lowerVal) {
            //console.log('sänk minsta till samma som högsta');
            lowerVal = upperVal;
            lowerSlider.value = lowerVal;
          }
          $('#price_filter_lower').text(lowerVal);
          $('#price_filter_upper').text(upperVal);
       }

       lowerSlider.oninput = function() {
         lowerVal = parseInt(lowerSlider.value);
         upperVal = parseInt(upperSlider.value);
         if (lowerVal >= upperVal) {
           //console.log('höj högsta till samma som minsta');
           upperVal = lowerVal;
           upperSlider.value = upperVal;
         }
         $('#price_filter_lower').text(lowerVal);
         $('#price_filter_upper').text(upperVal)
      }
    }
  }

    $('.ewd-uwcf-style-list').each(function() {
      var filterLanguageString = 'Filter by ';
      if (document.documentElement.lang == 'sv-SE') {
        filterLanguageString = 'Filtrera på ';
      }

      if ($(this).hasClass('ewd-uwcf-tag-filters-wrap')) {
        var categoryText = 'VARUMÄRKE';
      } else if ($(this).hasClass('ewd-uwcf-category-filters-wrap')) {
        var categoryText = 'KATEGORIER';
        //$(this).prependTo('#ewd-uwcf-filtering-form');
        $(this).hide();
      } else {
        if ($(this).attr('data-attribute_name')) {
          var categoryText = $(this).attr('data-attribute_name');
          if (categoryText == 'kon') {
            categoryText = 'Kön';
          } else if (categoryText == 'skaftlangd') {
            categoryText = 'Skaftlängd';
          }
        } else {
          var categoryText = 'FÄRG';
        }
      }
      $('.ewd-uwcf-all-attribute', this).addClass('button').css('padding', '10px 0').text('Visa alla');
      $('.ewd-uwcf-all-category', this).addClass('button').css('padding', '10px 0').css('margin-bottom', '28px').text('Visa alla kategorier');
      if ($(this).hasClass('ewd-uwcf-category-filters-wrap')) {

      } else {
        $(this).wrap('<div class="single-category"></div>');
        $(this).closest('.single-category').prepend('<span class="h4">' + categoryText + '</span>');
      }

      if($('.ewd-uwcf-selected').length > 0) {
        $('.ewd-uwcf-selected').each(function() {
          //$(this).closest('.single-category').addClass('open');
        });
      }
    });

    $('.category-menu-item a').click(function(e){
      e.preventDefault();
      var category = $(this).attr('href');
      if (category.indexOf('/') > -1) {
        category = category.split('/');
        if ($(this).attr('href')[$(this).attr('href').length - 1] == '/') {
          category = category[category.length - 2];
        } else {
          category = category[category.length - 1];
        }
      }
      console.log(category);
      if (window.location.search.indexOf('&') > -1 || window.location.search.indexOf('?') > -1) {
        if (window.location.search.indexOf('product_cat') > -1) {
          var product_cat = window.location.search.split('product_cat');
          product_cat = product_cat[1].split('?');
          if (product_cat[0].indexOf(category) < 0) {
            window.location.href = 'https://www.nsgk.se/webbshop/' + window.location.search.replace(product_cat[0], '=' + category);
          } else {
            window.location.href = 'https://www.nsgk.se/webbshop/' + window.location.search.replace('product_cat' + product_cat[0], '');
          }
        } else {
          window.location.href = 'https://www.nsgk.se/webbshop/' + window.location.search + '&product_cat=' + category;
        }
      } else {
       window.location.href = 'https://www.nsgk.se/webbshop/?product_cat=' + category; 
      }
    });
    

    $('.single-category .h4').click(function() {
      var parent = $(this).parent();
      if ($(parent).hasClass('open')) {
        $(parent).removeClass('open');
      } else {
        $(parent).addClass('open');
      }
    });

    // $('.single-category .h4').click(function() {
    //   var parent = $(this).parent();
    //   $(parent).toggleClass('open');
    // });
  }

  $('.wl-categories .categories li').each(function(){
    if ($(this).hasClass('active')) {
      $('.categories-menu').addClass('open');
    }
  })
}
